export default String.raw`
{% if config.B2B -%}
    {% assign wishlists = customer-profile.WishListsPagination -%}
    <div class="wishlist-list customer-wishlists-list-js">
            <div class="wishlist-list__header">
                <div class="navigation-header">
                    <h2>{{ translations.WishLists }} <span>({{wishlists.TotalItems}})</span></h2>
                </div>
                <button class="primary-action-button add-new-wishlist-in-cp-js" >
                    {{ translations.CreateWishList }}
                </button>
                <div class="message-popup-background add-new-wishlist-popup-js hidden-js container-to-hide-js">
                    <div class="popup-container">
                        <div class="data-form__header">
                            {{ translations.NewWishList }}
                            <button aria-label="hide-container" class="close-button hide-container-js">
                                <svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
                            </button>
                        </div>
                        <div class="data-form">
                            <div class="form__input-wrapper">
                                <label for="new-wishlist" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.Com_NAME }}</label>
                                <input id="new-wishlist" class="form__input-value input-value-js" name="new-wishlist" type="text" maxlength="500" required >
                                <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillName3 }}</div>
                            </div>
                            <div class="buttons-container new-wishlist">
                                <button aria-label="hide-container" class="pure-button hide-container-js">
                                    {{ translations.Cancel }}
                                    </button>
                                <button aria-label="add-new-wishlist" class="primary-action-button add-new-wishlist-js">
                                    {{ translations.Create }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {% if wishlists.TotalItems != 0 -%}
            <div class="form__input-wrapper wishlist-select">
                <div tabindex="0" class="form__input-value select-js select">
                    <label for="wishlistSelect" class="form__input-info input-info-js on-label">{{ translations.Sorting }}</label>
                    <select id="wishlistSelect" class="memory-js">
                        {% assign activeSortingOption = -1 -%}
                        {% for sortingType in wishlists.SortingOptions -%}
                            <option value="{{ sortingType.Text }}" {% if sortingType.Value == wishlists.SelectedSorting %}selected{% endif %}>
                                {{ sortingType.Text }}
                            </option>
                        {% endfor %}
                    </select>
                    <div class="select__input">
                        {% assign activeSortingOption = -1 -%}
                        {% for sortingType in wishlists.SortingOptions -%}
                            {% if sortingType.Value == wishlists.SelectedSorting -%}
                                {% assign activeSortingOption = sortingType.Text -%}
                            {% endif -%}
                        {% endfor %}
                        <span class="selected-js">
                            {% if activeSortingOption != -1 -%}
                                {{ activeSortingOption }}
                            {% else -%}
                                {{ translations.Sorting }}
                            {% endif -%}
                        </span>
                        <svg width="14px" height="14px">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{ settings.iconStyle }}"></use>
                        </svg>
                    </div>
                    <ul tabindex="0" role="listbox" class="select__options options-js" data-sorting-query="{{ wishlists.SortingQueryGET }}">
                        {% assign activeSortingOption = -1 -%}
                        {% for sortingType in wishlists.SortingOptions -%}
                            <li tabindex="0" data-value="{{ sortingType.Text }}" data-sorting-type="{{ sortingType.Value }}">
                                {{ sortingType.Text }}
                            </li>
                        {% endfor %}
                    </ul>
                </div>
            </div>
            {% endif -%}        

            <div class="wishlist__table-container">
                <table data-wishlist-details-url="{{page.Url}}?tab=wishlist-details" data-wishlist-query="{{customer-profile.WishListsQueryGET}}">
                    {% for wishlist in wishlists.Data -%}
                    <tbody>
                        <tr tabindex="0" class="row wishlist-item-container open-wishlist-details-js scroll-top-js" data-wishlist-id="{{ wishlist.Id }}" data-wishlist-name="{{ wishlist.Name }}">
                            <td class="wishlist-name">
                                {{ wishlist.Name }}
                            </td>
                            <td class="wishlist-double-rows">
                                <div>
                                    {{ translations.ReminderDate }}
                                </div>
                                <div>
                                    {% if wishlist.NotifyDate -%}
                                        {{ wishlist.NotifyDate | Date:'dd.MM.yyyy' }}
                                    {% else -%}
                                        -
                                    {% endif -%}
                                </div>
                            </td>
                            <td class="wishlist-double-rows">
                                <div>
                                    {{ translations.NumberOfProducts }}
                                </div>
                                <div>
                                    {{ wishlist.ProductCount }}
                                </div>
                            </td>
                            <td class="wishlist-products-images-container">
                                {% if wishlist.ImagesUrls -%}
                                    {% assign hideLastElement = false -%}
                                    {% assign imagesToDisplay = wishlist.ImagesUrls | Take: 5 | Size -%}
                                    {% for image in wishlist.ImagesUrls -%}
                                        {% if forloop.index == 5 -%}
                                            {% assign hideLastElement = true -%}
                                            <div class="item-container only-small-mobile-hide-element">
                                                {% if image.Id != -1 -%}
                                                    <img src="css/img/alo.gif" data-src="img/{{ image.Id }}/{{ image.Link }}" alt="{{ image.Alt }}">
                                                {% elseif image.externalUrl != -1 -%}
                                                    <img src="css/img/alo.gif" data-src="{{ image.externalUrl }}" alt="{{ image.Alt }}">
                                                {% endif -%}
                                            </div>
                                            {% break -%}
                                        {% else -%}
                                            <div class="item-container">
                                                {% if image.Id != -1 -%}
                                                    <img src="css/img/alo.gif" data-src="img/{{ image.Id }}/{{ image.Link }}" alt="{{ image.Alt }}">
                                                {% elseif image.externalUrl != -1 -%}
                                                    <img src="css/img/alo.gif" data-src="{{ image.externalUrl }}" alt="{{ image.Alt }}">
                                                {% endif -%}
                                            </div>
                                        {% endif -%}
                                    {% endfor -%}

                                    {% if wishlist.ProductCount > imagesToDisplay -%}
                                        <div class="item-container {% if hideLastElement -%} only-small-mobile-hide-element {% endif -%}">
                                            + {{wishlist.ProductCount | Minus: imagesToDisplay}}
                                        </div>
                                        {% if hideLastElement -%}
                                            {% assign imagesToDisplay = imagesToDisplay | Minus: 1 -%}
                                            <div class="item-container only-small-mobile-show-element">
                                                + {{wishlist.ProductCount | Minus: imagesToDisplay}}
                                            </div>
                                        {% endif -%}
                                    {% endif -%}
                                {% endif -%}
                            </td>
                            <td class="wishlist-delete-button">
                                <button class="close-button prepare-delete-wishlist-popup-js" aria-label="{{ translations.Delete }}" title="{{ translations.Delete }}">
                                    <svg width="24" height="24">
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#trash-alt-{{settings.iconStyle}}"></use>
                                    </svg>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    {% endfor -%}
                </table>
                {% include 'partials/common/pagination.html' -%}
            </div>
        <div class="message-popup-background delete-wishlist-popup-js hidden-js container-to-hide-js">
            <div class="popup-container">
                <div class="data-form">
                    <div class="data-form__header">
                        {{ translations.DeleteWishList }}
                        <button aria-label="hide-container" class="close-button hide-container-js">
                            <svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
                        </button>
                    </div>
                    <input type="hidden" name="wishlistId" >
                    <div>{{ translations.DeleteWishListInfo }} <strong>Koszyk Koszyk HR</strong> ?</div>
                    <div class="buttons-container">
                        <button aria-label="hide-container" class="pure-button hide-container-js">
                            {{ translations.Cancel }}
                        </button>
                        <button aria-label="delete-wishlist" class="primary-action-button delete-wishlist-js">
                            {{ translations.YesDelete }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {% if customer-profile.WishListsPagination.TotalItems == 0 -%}
        <div class="no-data">
            {{ translations.NoWishLists }}
        </div>
    {% endif -%}
{% else -%}
    {% assign whatPrice = translations.Brutto | Downcase -%}

    {% if customer.Cart.SubtotalPrices -%}
        {% assign whatPrice = translations.Netto | Downcase -%}
    {% endif -%}

    <div class="eshop__table-container" data-base="http:{{ page.BaseHref }}" data-group-id="{{ page.GroupId }}" data-group-name="{{ page.CurrentSiteNode.Name }}">
        <table>
            <colgroup>
                <col style="width:400px">
                <col style="width:140px">
                <col style="width:210px">
                <col style="width:140px">
            </colgroup>
            <thead>
                <tr>
                    <th>
                        {{ translations.Product }}
                    </th>
                    <th>
                        <div>
                            {{ translations.Quantity }}
                        </div>
                    </th>
                {% unless customer.HidePrices -%}
                    <th>{{ translations.Price }} {{ whatPrice }}</th>
                    <th>{{ translations.Value }} {{ whatPrice }}</th>
                {% endunless -%}
                    <th>
                        {{ translations.ReminderDate }}
                    </th>
                </tr>
            </thead>
            <tbody>
            {% include 'partials/wishlist/wishlist-table-item.html' for customer-profile.WishList -%}
            <tr>
                <td>
                    {{translations.ItemsQuantity}}: <span class="wishlist-counter-js">{{customer.WishListCount}}</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="no-data">{{ translations.YourWishListIsEmpty }}</div>
{% endif -%}
`